import axiosInstance from "../../../configurations/Axios";
import {API_ENDPOINTS} from "../../../constant/APIEndPoints";



export const submitQueryMultiSimRequest=async (queryMultiSimRequestModel)=>{
    try{
        const apiResponse=await axiosInstance.post(API_ENDPOINTS.SUBMIT_QUERY_MULTI_SIM,queryMultiSimRequestModel);
        return apiResponse.data;
    }catch (error){
        console.log(error);
        throw new Error(error);
    }
}

export const submitResumeDeleteSuspendRequest=async (resumeDeleteSuspendRequestModel)=>{
    try{
        const apiResponse=await axiosInstance.post(API_ENDPOINTS.SUBMIT_RESUME_DELETE_SUSPEND,resumeDeleteSuspendRequestModel);
        return apiResponse.data;
    }catch(error){
        console.log(error);
        throw new Error(error);
    }
}